import { MedidoresService } from './../../../../services/medidores.service';
import { MatDialogRef } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MedidorUltimaTransmision } from './../../../../../../_entities/medidores/medidorUltimaTransmision';

@Component({
	selector: 'kt-medidor-ultima-transmision',
	templateUrl: './medidor-ultima-transmision.component.html',
	styleUrls: ['./medidor-ultima-transmision.component.scss']
})
export class MedidorUltimaTransmisionComponent implements OnInit {

	public medidoresDataSource;

	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public fecha: any;
	public hora: any;
	 isDisabled: boolean = true;
	public datosReporte = [];


	constructor(private mapaService: MapaService,
		private datepipe: DatePipe,
		public dialogRef: MatDialogRef<MedidorUltimaTransmisionComponent>,
		private medidoresService: MedidoresService) { }

	ngOnInit() {
		this.obtenerMedidor();
	}

	obtenerMedidor() {
		this.medidoresService.obtenerUltimoMedidor().subscribe(
			(ultimaTransmision: MedidorUltimaTransmision[]) => {
				ultimaTransmision.map(ultima => {
					ultima.fechaHora = this.datepipe.transform(ultima.fechaHora, 'dd/MM/yyyy HH:mm a');
				})
				this.medidoresDataSource = ultimaTransmision;
				this.medidoresDataSource.forEach(medidor => {
					this.datosReporte.push({
						'Descripción': medidor.descripcion,
						'IMEI': medidor.imei.toString(),
						'Fecha y Hora': medidor.fechaHora,
						'Gasto': medidor.gasto + ' m3/h'
					});
				});
				if (this.datosReporte.length > 0) {
					this.isDisabled = false;
				}
			}
		)
	}

	ubicarPuntoHistorico(data) {
		this.mapaService.verMedidor(data);
		this.cerrarPopup();
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
